import React from 'react';
import ratioUtils from 'Components/utils/ratios/ratios.utils';
import { Image } from 'Components/frameworks/image/Image';
import { Text } from 'Components/frameworks/text/Text';
import { Title } from 'Components/frameworks/title/Title';
type Props = {
  className?: string;
  description: string | null | undefined;
  imageSrc?: string | null | undefined;
  title: string | null | undefined;
};
export function ProductFeatureDetailBrandInformation({
  className,
  description,
  imageSrc,
  title,
}: Props) {
  if (!description) {
    return null;
  }

  const desc = <Text text={description} />;
  return (
    <section className={className}>
      <Title
        className="mb-30 justify-center border-b-1 border-black text-center"
        hLevel={3}
        theme="title-brand-n1"
      >
        {title}
      </Title>
      {imageSrc ? ( // flow static analysis can't even get a boolean cast...
        <div className="-mx-20 flex flex-col sm:flex-row">
          <div className="flex-none px-20 sm:w-1/2">{desc}</div>
          <div className="mt-20 flex-none px-20 sm:mt-0 sm:w-1/2">
            <Image imageUrl={imageSrc} ratioKey={ratioUtils.XL} />
          </div>
        </div>
      ) : (
        desc
      )}
    </section>
  );
}
